<!-- 页面布局（顶部、内容、底部） 底部页-->
<template>
  <layout-center class="app-foot-nav">
    <el-row :gutter="10" justify="center">
      <el-col :span="4">
        <img src="@/assets/logo/bzzy-logo.svg"/>
      </el-col>

      <el-col :span="4" >
        <ul>
          <li>关于我们</li>
          <li @click="pushPage('/aboutUs', 'qygk')">企业概况</li>
          <li @click="pushPage('/aboutUs', 'qywh')">企业文化</li>
          <li @click="pushPage('/aboutUs', 'zzry')">资质荣誉</li>
        </ul>
      </el-col>

      <el-col :span="4">
        <ul>
          <li>解决方案</li>
          <li @click="pushPage('/solution')">无纸化应用</li>
          <li @click="pushPage('/solution')">诉讼服务</li>
          <li @click="pushPage('/solution')">审判服务</li>
        </ul>
      </el-col>

      <el-col :span="4">
        <ul>
          <li @click="openPage">友情链接</li>
          <li @click="openPage('https://www.court.gov.cn/')">最高人民法院</li>
          <li @click="openPage('https://www.chinacourt.org/index.shtml')">中国法院网</li>
          <li @click="openPage('http://www.guizhoucourt.gov.cn/')">贵州省高级人民法院</li>
        </ul>
      </el-col>

      <el-col :span="4">
        <ul>
          <li>联系我们</li>
          <li>服务热线</li>
          <li>0851-87973755</li>
        </ul>
      </el-col>

      <el-col :span="4">
        <img src="@/assets/images/index/gfwx.png"/>
      </el-col>
    </el-row>
  </layout-center>

  <div class="app-foot">
    <div>
      Copyright ©2022
      {{ company.name }}
      <img src="@/assets/images/index/foot.svg">
      {{ company.putOnRecords }}
      {{ company.address }}
    </div>
  </div>
</template>

<script>

import {company} from '@/global/constant'
import {useRouter} from "vue-router"

export default {
  name: "AppFoot",
  setup() {
    const router = useRouter()

    const pushPage = (path, type) => {
      if(type) {
        router.push({path: path, query: {type: type}})
      } else {
        router.push({path: path})
      }
    }

    const openPage = (url) => {
      window.open(url)
    }

    return {
      company,
      pushPage,
      openPage
    }

  }
}
</script>

<style scoped>
.app-foot {
  background-color: #ebebec;
  text-align: center;
}

.app-foot > div {
  font-family: PingFangSC-Regular, serif;
  font-size: 14px;
  color: #616871;
  letter-spacing: 1px;
  display: inline-block;
  height: 60px;
  line-height: 60px;
}

.app-foot > div > img {
  position: relative;
  top: 5px;
}

.app-foot-nav > div > div > div {
  padding: 50px 0 50px 0;
}

li {
  display: block;
  font-family: PingFangSC-Regular, serif;
  font-size: 16px;
  color: #202228;
  padding-bottom: 20px;
  cursor: pointer;
  text-align: center;
}

li:nth-child(1) {
  font-family: PingFangSC-Medium, serif;
  font-size: 23px;
  font-weight: 600;
  color: #51565C;
}
</style>
